module.exports = __webpack_public_path__ + "img/slide5.e158e861.jpeg";